import { flexRender, Row } from '@tanstack/react-table';
import { Fragment, ReactNode } from 'react';
import { RowWithId } from '@/components/table/types/RowWithId.ts';
import { FieldImportance } from '@/components/table/types/FieldImportance.ts';
import {
  OPTIONS_COLUMN_ID,
  SELECT_COLUMN_ID,
} from '@/components/table/preferences/columnPreferences.ts';

const isDataCell = (columnId: string) =>
  columnId !== SELECT_COLUMN_ID && columnId !== OPTIONS_COLUMN_ID;

const MobileRecordCard = <T extends RowWithId>({
  row,
  actions,
}: {
  row: Row<T>;
  actions?: ReactNode;
}) => {
  // `getAllCells`, nie `getVisibleCells`: schowanie kolumny na desktopie jest
  // ustawieniem szerokiej tabeli i nie ma prawa okroić karty.
  const cells = row.getAllCells().filter((cell) => isDataCell(cell.column.id));
  const primary = cells.filter(
    (cell) =>
      cell.column.columnDef.meta?.importance === FieldImportance.PRIMARY,
  );
  const secondary = cells.filter(
    (cell) =>
      cell.column.columnDef.meta?.importance === FieldImportance.SECONDARY,
  );

  return (
    <li className="flex items-start gap-2 border-b border-neutral-100 px-1 py-3">
      <div className="flex min-w-0 flex-1 flex-col gap-1.5">
        {/* Jeden wiersz na wszystkie PRIMARY: imię i nazwisko to dwie kolumny, a mają się czytać jak jedna nazwa. */}
        <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
          {primary.map((cell) => (
            <div
              key={cell.id}
              className="min-w-0 text-base font-bold leading-5 text-base-text"
            >
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </div>
          ))}
        </div>
        <div className="grid grid-cols-[auto_1fr] items-baseline gap-x-3 gap-y-1 text-sm leading-[18px]">
          {secondary.map((cell) => (
            <Fragment key={cell.id}>
              <span className="text-xs font-medium text-neutral-500">
                {typeof cell.column.columnDef.header === 'string'
                  ? cell.column.columnDef.header
                  : cell.column.id}
              </span>
              {/* Link renderuje własne font-semibold i text-base-text; bez nadpisania krzyczałby głośniej niż tytuł karty. */}
              <span className="min-w-0 font-medium text-neutral-500 [&_a]:font-medium [&_a]:text-neutral-500">
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </span>
            </Fragment>
          ))}
        </div>
      </div>
      {actions}
    </li>
  );
};

export default MobileRecordCard;
